module.exports = __webpack_public_path__ + "img/guide03.8e1ec3d9.png";